import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  generateRecaptchaToken
} from "./chunk-W4XMZLKW.mjs";
import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/auth/register.ts
import { generateMd5, getItem, getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var signup = (_0) => __async(void 0, [_0], function* ({ email, locale }) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s;
  try {
    const captcha = yield generateRecaptchaToken("signup");
    const signature = generateMd5(email);
    const lang = getLocaleOnly(locale);
    const data = yield fetchClient({
      url: "/signup",
      baseUrl: (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.authApi,
      options: {
        method: "POST",
        body: JSON.stringify({
          email,
          captcha,
          signature,
          app_source: (_d = (_c = ApiConfig.config) == null ? void 0 : _c.wbk) == null ? void 0 : _d.appSource,
          check_user: true,
          skip_email_verification: true,
          lang
        })
      }
    });
    if ((_e = data == null ? void 0 : data.error) == null ? void 0 : _e.user) {
      return { data: { email }, message: "existant_user" };
    }
    if ((_f = data == null ? void 0 : data.data) == null ? void 0 : _f.otp) {
      return { otp: data.data.otp };
    }
    if (((_g = data == null ? void 0 : data.status) == null ? void 0 : _g.toLowerCase()) === "success" || ((_i = (_h = data == null ? void 0 : data.original) == null ? void 0 : _h.status) == null ? void 0 : _i.toLowerCase()) === "success") {
      return ((_j = data == null ? void 0 : data.data) == null ? void 0 : _j.user) ? { user: (_k = data == null ? void 0 : data.data) == null ? void 0 : _k.user } : data.original;
    }
    const possibleMessage = ((_l = data == null ? void 0 : data.error) == null ? void 0 : _l.mobile) || ((_m = data == null ? void 0 : data.error) == null ? void 0 : _m.phone) || ((_n = data == null ? void 0 : data.error) == null ? void 0 : _n.cell_number) || ((_p = (_o = data == null ? void 0 : data.original) == null ? void 0 : _o.error) == null ? void 0 : _p.description) || ((_q = data == null ? void 0 : data.error) == null ? void 0 : _q.description) || ((_s = (_r = data == null ? void 0 : data.error) == null ? void 0 : _r.captcha) == null ? void 0 : _s[0]);
    throw new Error(possibleMessage);
  } catch (error) {
    throw new Exception({
      error,
      name: "signupException",
      context: { tags: { journey: "auth" } }
    });
  }
});
var register = (_0) => __async(void 0, [_0], function* ({ user, locale = "en" }) {
  var _a, _b, _c;
  try {
    const lang = getLocaleOnly(locale);
    const captcha = yield generateRecaptchaToken("signup");
    const signature = generateMd5(user.email || "");
    const savedUtms = getItem("utms");
    const utm = savedUtms ? JSON.parse(savedUtms) : null;
    const data = yield fetchClient({
      url: `/register?lang=${lang}`,
      baseUrl: (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.authApi,
      options: {
        method: "POST",
        body: JSON.stringify(__spreadValues(__spreadProps(__spreadValues({}, user), {
          lang,
          captcha,
          signature,
          skip_phone_validation: true,
          check_user: true
        }), utm))
      }
    });
    if (((_c = data.status) == null ? void 0 : _c.toLowerCase()) !== "success") {
      throw data.error;
    }
    const fullCell = `${user.country_code ? `+${user.country_code}` : "0"}${data.data.user.cell_number}`;
    return __spreadProps(__spreadValues({}, data.data.user), {
      cell_number: fullCell,
      phone: fullCell
    });
  } catch (error) {
    throw new Exception({
      error,
      name: "registerException",
      context: error
    });
  }
});

export {
  signup,
  register
};
//# sourceMappingURL=chunk-ZI4WAXZU.mjs.map